import { useState, useEffect } from "react";

export const useHttp = (url, token) => {
    const [loaded, setLoaded] = useState(false);
    const [fetchedData, setFetchedData] = useState(null)
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/${url}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Token ${token}`
      }
    })
      .then(result => result.json())
      .then(result => {
        setFetchedData(result);
        setLoaded(true);
      })
      .catch(e => {
        console.error(e);
        setLoaded(false);
      });
  }, [token, url]);

  return [loaded, fetchedData];
};
export const httpGet = async (url, token) => {
  return await fetch(`${process.env.REACT_APP_API_URL}/${url}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Token ${token}`
    }
  })
    .then(result => result.json())
    .then(result => {
      return {response: result, loaded: true}
    })
    .catch(e => {
      console.error(e);
      return {loaded: false, response:e};
    });
};
export const httpPost = async (url, body, token, method) => {
  let headers = {};
  token ? headers = { "content-type": "application/json", Authorization: `Token ${token}` } : headers = { "content-type": "application/json" }
  return await fetch(`${process.env.REACT_APP_API_URL}/${url}`, {
    method: method ? method : "POST",
    headers: headers,
    body: JSON.stringify(body)
  })    
    .then(response => {
      if (response.ok){
        return response.json()
      }
      return Promise.reject(response)
    }).then(results => ({loaded: true, response:results}))
    .catch(async error => {
      var errs = await error.json().then(r => {
        return r.errors.map(e => e.detail).join(' ')
      })
      return {loaded: false, response:errs};
    });
};